export class SwitchCompanyLoginModel {
  constructor(
    public SelectedMainContact: number = null
  ){}
}
